import SearchHeader from "./SearchHeader";
export default SearchHeader;
export { default as SearchHeader } from "./SearchHeader";
